import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "badge text-bg-danger"
};
const _hoisted_2 = { class: "row mb-5" };
const _hoisted_3 = { class: "col-lg-6 col-12" };
const _hoisted_4 = { class: "table mb-3" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "border-5 border-start-0 border-end-0 border-top-0" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = ["href"];
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "fw-bold text-danger"
};
const _hoisted_13 = { class: "col-lg-6 col-12" };
const _hoisted_14 = { class: "table table-hover align-middle" };
const _hoisted_15 = { scope: "col" };
const _hoisted_16 = { scope: "col" };
const _hoisted_17 = { scope: "col" };
const _hoisted_18 = { scope: "col" };
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = ["href"];
const _hoisted_21 = { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" };
const _hoisted_22 = { class: "table" };
const _hoisted_23 = { scope: "col" };
const _hoisted_24 = { scope: "col" };
const _hoisted_25 = { scope: "col" };
const _hoisted_26 = { scope: "col" };
const _hoisted_27 = { class: "align-middle" };
const _hoisted_28 = { class: "align-middle" };
const _hoisted_29 = { key: 1 };
const _hoisted_30 = { class: "align-middle" };
const _hoisted_31 = { class: "align-middle" };
const _hoisted_32 = { class: "align-middle" };
const _hoisted_33 = { class: "d-block fw-bold" };
const _hoisted_34 = {
    key: 0,
    class: "d-block text-danger"
};
const _hoisted_35 = { class: "row" };
const _hoisted_36 = { class: "col-12 col-lg-6 col-xl-4" };
const _hoisted_37 = { class: "table align-middle" };
const _hoisted_38 = { class: "d-block fw-bold" };
const _hoisted_39 = { class: "d-block small" };
const _hoisted_40 = { class: "fw-bold" };
const _hoisted_41 = { class: "fw-bold" };
const _hoisted_42 = { class: "bg-light" };
const _hoisted_43 = { class: "fs-5 text-primary" };
const _hoisted_44 = { class: "fs-5 text-primary fw-bold" };
import { formatters } from '@/Composables/formatters';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerOrder',
    props: {
        order: Object,
    },
    setup(__props) {
        let { formatCurrency, formatDate } = formatters();
        const { t } = useI18n();
        const props = __props;
        return (_ctx, _cache) => {
            const _component_Link = _resolveComponent("Link");
            return (_openBlock(), _createElementBlock("div", null, [
                (props.order.payments.length == 0 && !props.order.paymentByBankTransfer)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(t)('Noch keine Zahlungseingänge vermerkt')), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("table", _hoisted_4, [
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Status')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.status), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Bestellung vom')), 1),
                                    _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.createdAt, true)) + " Uhr", 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Bezahlt')), 1),
                                    _createElementVNode("td", null, [
                                        (props.order.paidAt)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(formatDate)(props.order.paidAt, true)) + " " + _toDisplayString(_unref(t)('Uhr')), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
                                    ])
                                ]),
                                (props.order.cancelledAt)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                                        _createElementVNode("th", null, _toDisplayString(_unref(t)('Storniert')), 1),
                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.cancelledAt, true)) + " " + _toDisplayString(_unref(t)('Uhr')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("tr", _hoisted_8, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Letzte Änderung')), 1),
                                    _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.updatedAt, true)) + " " + _toDisplayString(_unref(t)('Uhr')), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Bestellnr.')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.orderId), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Rechnungsadresse')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.invoiceAddress.name), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Lieferadresse')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.deliveryAddress.name), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Umsatzsteuer-ID/Vat-ID')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.vatId), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('E-Mail')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.email), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Telefon')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.phone), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Bezahlart')), 1),
                                    _createElementVNode("td", null, [
                                        _createTextVNode(_toDisplayString(props.order.paymentOption) + " ", 1),
                                        (props.order.paymentUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createElementVNode("a", {
                                                    href: props.order.paymentUrl,
                                                    target: "_blank"
                                                }, _toDisplayString(_unref(t)('Zahlungslink/Beleg')), 9, _hoisted_10)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Gewünschtes Lieferdatum')), 1),
                                    _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.order.requestDeliveryDate)), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Anmerkung des Kunden')), 1),
                                    _createElementVNode("td", null, _toDisplayString(props.order.customerNotes), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Zusätzliche Informationen')), 1),
                                    (__props.order.advertistingPurpose)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_unref(t)('Der Kunde stimmt zu, dass seine konfigurierten Produkte zu Werbezwecken verwendet werden dürfen.')), 1))
                                        : _createCommentVNode("", true),
                                    (!__props.order.advertistingPurpose)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_unref(t)('Der Kunde stimmt NICHT zu, dass seine konfigurierten Produkte zu Werbezwecken verwendet werden dürfen.')), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("table", _hoisted_14, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_15, _toDisplayString(_unref(t)('Belegdatum')), 1),
                                    _createElementVNode("th", _hoisted_16, _toDisplayString(_unref(t)('Belegnummer')), 1),
                                    _createElementVNode("th", _hoisted_17, _toDisplayString(_unref(t)('Anmerkung für den Kunden')), 1),
                                    _createElementVNode("th", _hoisted_18, _toDisplayString(_unref(t)('Download')), 1)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.confirmations, (confirmation) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(confirmation.createdAt, true)), 1),
                                        _createElementVNode("td", null, _toDisplayString(confirmation.referenceNo), 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("small", {
                                                innerHTML: confirmation.notes
                                            }, null, 8, _hoisted_19)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("a", {
                                                href: confirmation.downloadUrl
                                            }, [...(_cache[0] || (_cache[0] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "24",
                                                        fill: "currentColor",
                                                        class: "bi bi-file-earmark-pdf",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" }),
                                                        _createElementVNode("path", { d: "M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" })
                                                    ], -1)
                                                ]))], 8, _hoisted_20)
                                        ])
                                    ]));
                                }), 256))
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("h3", _hoisted_21, _toDisplayString(_unref(t)('Positionen')), 1),
                _createElementVNode("table", _hoisted_22, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _cache[1] || (_cache[1] = _createElementVNode("th", { scope: "col" }, "#", -1)),
                            _createElementVNode("th", _hoisted_23, _toDisplayString(_unref(t)('Produkt/Konfiguration')), 1),
                            _createElementVNode("th", _hoisted_24, _toDisplayString(_unref(t)('Einzelpreis')), 1),
                            _createElementVNode("th", _hoisted_25, _toDisplayString(_unref(t)('Menge')), 1),
                            _createElementVNode("th", _hoisted_26, _toDisplayString(_unref(t)('Gesamt')), 1)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.orderPositions, (position, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_27, _toDisplayString((index) + 1), 1),
                                _createElementVNode("td", _hoisted_28, [
                                    (position.editRoute)
                                        ? (_openBlock(), _createBlock(_component_Link, {
                                            key: 0,
                                            href: position.editRoute
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(position.productDetails), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["href"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(position.productDetails), 1))
                                ]),
                                _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(formatCurrency)(position.singlePrice)), 1),
                                _createElementVNode("td", _hoisted_31, _toDisplayString(position.amount), 1),
                                _createElementVNode("td", _hoisted_32, [
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(formatCurrency)(position.totalPrice)), 1),
                                    (position.originTotalPrice)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                            _createElementVNode("del", null, _toDisplayString(_unref(formatCurrency)(position.originTotalPrice)), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]));
                        }), 128))
                    ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("table", _hoisted_37, [
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, [
                                        _createTextVNode(_toDisplayString(_unref(t)('Versand')) + " (" + _toDisplayString(__props.order.deliveryType.name) + ") ", 1),
                                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(_toDisplayString((__props.order.totalWeight / 1000).toFixed(2)) + " kg " + _toDisplayString(_unref(t)('nach')) + " " + _toDisplayString(__props.order.deliveryType.countryName), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(formatCurrency)(__props.order.deliveryPrice)), 1),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)('exkl. MwSt.')), 1)
                                    ])
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_unref(t)('Gesamtsumme ohne MwSt.')), 1),
                                    _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(formatCurrency)(__props.order.totalPrice)), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_unref(t)('zzgl.')) + " " + _toDisplayString(__props.order.taxRate) + " % " + _toDisplayString(_unref(t)('MwSt.')), 1),
                                    _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(formatCurrency)(__props.order.tax)), 1)
                                ]),
                                _createElementVNode("tr", _hoisted_42, [
                                    _createElementVNode("th", _hoisted_43, _toDisplayString(_unref(t)('Gesamtsumme inkl. MwSt.')), 1),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(_unref(formatCurrency)(__props.order.totalPriceInclTax)), 1)
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
